module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/hiking@3x_e12dad.jpg";